// extracted by mini-css-extract-plugin
export default {"container":"Head_container__KjsCl","left":"Head_left__EbgmK","profile":"Head_profile__1NnUY","details":"Head_details__egvES","hidden":"Head_hidden__At-Za"};